import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GenericRepository } from "../../generic-repository/GenericRepository";
import { IProductionPostingSetupRepository } from "./IProductionPostingSetupRepository";
import { ProductionPostingSetup } from "src/app/models/Production/production-posting-setup";
import { ResponseModel } from "src/app/models/SharedModels/response.model";

@Injectable(
    {
        providedIn: "root"
    }
)
export class ProductionPostingSetupRepository extends GenericRepository<ProductionPostingSetup> implements IProductionPostingSetupRepository {

    url: string = environment.urlAddress;
    constructor(protected _http: HttpClient) {
        super(_http, 'api/ProductionPostingSetup', environment.urlAddress);
    }

    GetRec(code: string): Observable<ResponseModel> {
        return this.Get('Select/' + code).pipe(map(this.extractData), catchError(this.handleError));
    }
}